import * as React from 'react';

import { GenericError, GenericErrorProps } from '../components/GenericError';
import { Layout } from '../components/Layout';

const ErrorPage: React.FC<GenericErrorProps> = (props) => {
  const renderContent = () => <GenericError {...props} />;

  return <Layout renderContent={renderContent} />;
};

export default ErrorPage;
